import { requiresAuth, requiresTerms } from "@/middleware";

const EnrollmentView = () => import("./EnrollmentView.vue");
const enrollmentRoutes = [
  {
    path: "/enrollment/:enrollmentId",
    name: "Enrollment",
    component: EnrollmentView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms]
    }
  }
];

export default enrollmentRoutes;
